<script setup lang="ts">
/** The four season medals (`/art/season/<tier>.webp`) in a row, each in a brass-ringed round and named, slamming in one after another. */
import { useI18n } from '@/i18n';
import { SEASON_TIER_IDS, seasonArt } from '@/ui/panel/art-path';

const { t } = useI18n();
</script>

<template>
    <div class="medals">
      <h3 class="k-label medals-title">{{ t('landing.ranks.medals') }}</h3>
      <ul class="medal-row">
        <li v-for="(tier, i) in SEASON_TIER_IDS" :key="tier" class="medal" data-slam :style="{ '--i': i }">
          <img :src="seasonArt(tier)" :alt="t(`season.tier.${tier}`)" width="120" height="120" loading="lazy" decoding="async" />
          <span class="k-label medal-name">{{ t(`season.tier.${tier}`) }}</span>
        </li>
      </ul>
    </div>
</template>

<style scoped>
.medals {
  display: grid;
  justify-items: center;
  gap: 14px;
  margin-top: clamp(32px, 5vw, 64px);
}

.medals-title {
  margin: 0;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.medal-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: clamp(8px, 2vw, 24px);
  width: min(640px, 100%);
  margin: 0;
  padding: 0;
  list-style: none;
}

.medal {
  display: grid;
  justify-items: center;
  gap: 6px;
}

.medal img {
  width: min(100%, 120px);
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 0 0 3px #0d141c, 0 0 0 6px #b98a3a, 0 10px 16px rgba(0, 0, 0, 0.5);
}

.medal-name {
  font-size: 0.9rem;
  text-transform: uppercase;
}
</style>
